import { Stack, Typography } from '@mui/material'
import NextLink from 'next/link'
import { BrandLogo } from 'ui-components/components/atoms/BrandLogo'

interface FormHeaderProps {
  logo?: boolean
  title?: string
  subtitle?: any
  align?: 'left' | 'center'
}

export function AuthFormHeader(props: FormHeaderProps) {
  const { logo = true, title, subtitle, align = 'left', ...rest } = props

  const aligns = {
    left: {
      textAlign: 'left',
      alignItems: 'flex-start'
    },
    center: {
      textAlign: 'center',
      alignItems: 'center'
    }
  }

  return (
    <Stack
      spacing={3}
      sx={{ ...aligns[align] }}
      {...rest}
    >
      {logo ? (
        <NextLink href='/'>
          <BrandLogo
            variant='logoCopy'
            size='lg'
          />
        </NextLink>
      ) : null}

      <Stack spacing={1}>
        <Typography
          variant='next:h5'
          letterSpacing='tight'
          fontWeight={600}
        >
          {title}
        </Typography>
        {typeof subtitle === 'string' ? (
          <Typography variant='next:subtitle1'>{subtitle}</Typography>
        ) : (
          subtitle
        )}
      </Stack>
    </Stack>
  )
}
